/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_CurrentInputs */

const en_us2_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I train currently`)
};

const pt_br2_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino atualmente`)
};

const es_419_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreno actualmente`)
};

const pt_pt2_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino atualmente`)
};

const fr_fr2_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je m'entraîne actuellement`)
};

const de_de2_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich trainiere aktuell`)
};

const it_it2_onboarding_experience_current = /** @type {(inputs: Onboarding_Experience_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi alleno attualmente`)
};

/**
* | output |
* | --- |
* | "I train currently" |
*
* @param {Onboarding_Experience_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_current = /** @type {((inputs?: Onboarding_Experience_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_current(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_current(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_current(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_current(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_current(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_current(inputs)
	return en_us2_onboarding_experience_current(inputs)
});
export { onboarding_experience_current as "onboarding.experience.current" }